<template>
  <div class="d-flex flex-column border-end rounded-start h-100">
    <button
      type="button"
      class="btn btn-light btn-sm button-up border-bottom"
      :disabled="isAtTop"
      :aria-label="$t('backend.candidacy.components.position_controls.up')"
      @click.prevent="$emit('move-up')"
    >
      <AVIcon icon="chevron-up" />
    </button>

    <div
      class="d-flex align-items-center justify-content-center bg-light position-index"
      :aria-label="$t('backend.candidacy.components.position_controls.position', { position: position })"
    >
      <strong aria-hidden="true">{{ position }}</strong>
    </div>

    <button
      type="button"
      class="btn btn-light btn-sm button-down border-top"
      :disabled="isAtBottom"
      :aria-label="$t('backend.candidacy.components.position_controls.down')"
      @click.prevent="$emit('move-down')"
    >
      <AVIcon icon="chevron-down" />
    </button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "PositionControls",
  emits: ["move-up", "move-down"],
  props: {
    position: {
      type: Number,
      required: true
    },
    totalItems: {
      type: Number,
      required: true,
    },
  },
  computed: {
    isAtTop() {
      return this.position === 1;
    },
    isAtBottom() {
      return this.position === this.totalItems;
    },
  },
});
</script>

<style scoped>
.button-up {
  border-radius: 0;
  border-top-left-radius: 5px;
  flex: 0 1 2rem;
}

.button-down {
  border-radius: 0;
  border-bottom-left-radius: 5px;
  flex: 0 1 2rem;
}

.position-index {
  width: 2rem;
  min-height: 2rem;
  flex: 1 1 auto;
}
</style>
